export default class QueryKeys {
	static forFeatureFlags() {
		return [ 'featureFlags' ];
	}
}
